import { ManualAddressInputPayload } from '@/components/BaseAddressInputs.vue';
import { SAVED_SUGGESTIONS_KEY } from '@/constants/utils';
import { StorageSerializers, useStorage } from '@vueuse/core';

export type ManualAddressInputWithDescription = ManualAddressInputPayload & { description: string };

export type SavedAddressSuggestion = {
  timestamp: string;
  address: ManualAddressInputWithDescription;
};

const usePreviousSuggestions = () => {
  const savedSuggestions = useStorage<Record<string, SavedAddressSuggestion> | null>(
    SAVED_SUGGESTIONS_KEY,
    null,
    undefined,
    {
      serializer: StorageSerializers.object,
    }
  );

  const isEmpty = computed(() => {
    if (!savedSuggestions.value) return true;
    return Object.keys(savedSuggestions.value).length === 0;
  });

  interface SaveAddressParams {
    address: ManualAddressInputWithDescription;
    id: string;
  }
  const saveAddress = ({ address, id }: SaveAddressParams) => {
    if (!savedSuggestions.value) savedSuggestions.value = {};
    savedSuggestions.value[id] = { address, timestamp: new Date().toISOString() };
  };

  return {
    savedSuggestions,
    isEmpty,
    saveAddress,
  };
};

export default usePreviousSuggestions;
